import * as Chartist from 'chartist';
import tooltipPlugin from './chartist/tooltip_plugin';

// This is a needed side-effect for disco as well
tooltipPlugin.register(Chartist);

export default Chartist;



// WEBPACK FOOTER //
// ./javascripts/components/chartist-with-plugins.js